const NotificationsStore = {
  namespaced: true,
  state: {
    alert: {
      name: null,
    },
    snackbar: null,
    modal: null,
  },
  actions: {
    showSnackbar({ commit }, snackbar) {
      commit('showSnackbar', snackbar);
    },
    hideSnackbar({ commit }) {
      commit('hideSnackbar');
    },
    showAlert({ commit }, alert) {
      commit('showAlert', alert);
    },
    hideAlert({ commit }) {
      commit('hideAlert');
    },
    hideNetworkAlert({ commit }) {
      commit('hideNetworkAlert');
    },
    showUnsavedChangesModal({ commit }, data) {
      commit('showUnsavedChangesModal', data);
    },
    hideUnsavedChangesModal({ commit }) {
      commit('hideUnsavedChangesModal');
    },
  },
  mutations: {
    showSnackbar(state, snackbar) {
      state.snackbar = snackbar;
    },
    hideSnackbar(state) {
      state.snackbar = null;
    },
    showAlert(state, alert) {
      state.alert = alert;
    },
    hideAlert(state) {
      state.alert = { name: null };
    },
    hideNetworkAlert(state) {
      if (state.alert.name === 'network') {
        state.alert = { name: null };
      }
    },
    showUnsavedChangesModal(state, { header, body, agreeCallback }) {
      const callback = agreeCallback || (() => {});
      state.modal = Object.assign({}, state.modal, { header, body, callback });
    },
    hideUnsavedChangesModal(state) {
      state.modal = null;
    },
  },
  getters: {
    alert(state) {
      return state.alert;
    },
    snackbar(state) {
      return state.snackbar;
    },
    modal(state) {
      return state.modal;
    },
  },
};

export default NotificationsStore;
